module.exports = __webpack_public_path__ + "static/media/artwork.f499ddf2.jpg";